const items = [
  'Arquitetura de Receita',
  'Atrair',
  'Qualificar',
  'Vender',
  'Receber bem',
  'Entregar com qualidade',
  'Fazer voltar',
  'Funil Completo',
  '6 etapas do começo ao fim',
  'IA com objetivo claro',
];

export function HeroMarquee() {
  return (
    <div className="relative w-full overflow-hidden mask-fade-x py-6 border-y border-white/5">
      <div className="flex w-max animate-marquee-x gap-12">
        {[...items, ...items, ...items].map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-12 text-sm text-ink-500 whitespace-nowrap"
          >
            <span>{item}</span>
            <span aria-hidden className="text-brand-300/60">
              ◇
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
